import { render, staticRenderFns } from "./collecDesc.vue?vue&type=template&id=674cc3a0&scoped=true"
import script from "./collecDesc.vue?vue&type=script&lang=js"
export * from "./collecDesc.vue?vue&type=script&lang=js"
import style0 from "./collecDesc.vue?vue&type=style&index=0&id=674cc3a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674cc3a0",
  null
  
)

export default component.exports